module.exports = __webpack_public_path__ + "b3ee7bb5a3e3fec86a569794eaeb58ba.png";